import React, { memo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import SelectType from './SelectType';
import RadioType from './RadioType';

function Answer() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { compress } = engine.getSubjectData(id);
  const Component = compress ? SelectType : RadioType;

  return <Component />;
}

export default memo(Answer);
